import { type RequestPayload, router } from "@inertiajs/core";
import { DocumentForm } from "../../../components/document/general/DocumentForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Document } from "../../../models/document";
import { document_path, documents_path } from "../../../routes";

type DocumentEditProps = {
  document: Document;
};

export default function DocumentEdit({ document }: DocumentEditProps) {
  const { pathWithYearContext } = useYearContext();

  return (
    <ContentShell title={`Dokument ${document.title}`} onBack={() => router.get(pathWithYearContext(documents_path))}>
      <DocumentForm
        document={document}
        apprentices={[]}
        saveButtonLabel="Speichern"
        onSubmit={(values: RequestPayload) =>
          router.patch(pathWithYearContext(document_path, document.id), values, {
            forceFormData: true,
          })
        }
      />
    </ContentShell>
  );
}
